<template>
  <el-dialog class="dialog" title="请完善您的个人信息以便于我们更好为您服务" :visible="visible" :show-close='false' width="420px">

    <el-form label-width="80px" :rules="rules" ref="imporveForm" label-position="left" :model="form"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
      <el-form-item label="称呼" class="default-size" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="公司简称" class="default-size" prop="company.name">
        <el-input v-model="form.company.name"></el-input>
      </el-form-item>
      <el-form-item label="微信" class="default-size" prop="wx_number">
        <el-input v-model="form.wx_number" placeholder="如您不方便电话联系，请填写微信号联系"></el-input>
      </el-form-item>
      <el-form-item label="所属行业" prop="attribute.industry">
        <el-select v-model="form.attribute.industry" placeholder="为了更方便顾问给您推荐媒体，请填写行业" style="width: 100%;">
          <el-option v-for="item in industry" :key="item.id" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onSubmit" style="width:100%" :disabled="disabled">确定</el-button>
        </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    var budget = (rule, value, callback) => {
      if (value > 10000000 || value < 1) {
        callback(new Error("请输入合理的预算金额"));
      } else {
        callback();
      }
    };

    return {
      visible: false,
      industry: [],
      taxonomies: [
        {
          label: "小红书",
          value: "小红书"
        },
        {
          label: "抖音",
          value: "抖音"
        },
        {
          label: "微信",
          value: "微信"
        },
        {
          label: "微博",
          value: "微博"
        },
        {
          label: "短视频",
          value: "短视频"
        },
        {
          label: "直播",
          value: "直播"
        },
        {
          label: "软文",
          value: "软文"
        },
        {
          label: "其他",
          value: "其他"
        }
      ],
      form: {
        scope: "attribute",
        name: "",
        qq: "",
        wx_number: "",
        company: {},
        attribute: {
          taxonomies: []
        }
      },
      disabled: false,
      rules: {
          wx_number: [{
            message: "请输入微信号码",
            trigger: "blur,change"
          }
        ],
        name: [{
          required: true,
          message: "请输入称呼",
          trigger: "blur,change"
        }],
        "company.name": [{
          required: true,
          message: "请输入公司名称",
          trigger: "blur,change"
        }],
        "attribute.taxonomies": [{
          required: true,
          message: "请选择推广类型",
          trigger: "blur,change"
        }],
        "attribute.industry": [{
          message: "请选择行业",
          trigger: "blur,change"
        }]
      }
    };
  },
  computed: {
    profileStore: {
      get() {
        return this.$store.state.profile;
      }
    }
  },
  watch: {
    profileStore(v) {
      if (!v || !v.id) {
        return;
      }

      if (v.verify_type || v.license_image || v.user_id) {
        console.log('跳过认证数据更新');
        return;
      }

      if (!v.name && !v.company) {
        console.log('跳过不完整的数据');
        return;
      }

      this.$nextTick(() => {
        this.form.scope = v.scope || 'attribute';
        this.form.name = v.name || '';
        this.form.qq = v.qq || '';
        this.form.wx_number = v.wx_number || '';

        if (v.company && typeof v.company === 'object') {
          this.$set(this.form, 'company', JSON.parse(JSON.stringify(v.company)));
        } else {
          this.$set(this.form, 'company', {});
        }

        if (v.attribute && typeof v.attribute === 'object') {
          this.$set(this.form, 'attribute', {
            taxonomies: Array.isArray(v.attribute.taxonomies) ? v.attribute.taxonomies : [],
            industry: v.attribute.industry || ''
          });
        } else {
          this.$set(this.form, 'attribute', {
            taxonomies: [],
            industry: ''
          });
        }

        const hasName = v.name && v.name.trim() !== '';
        const hasCompanyName = v.company && v.company.name && v.company.name.trim() !== '';
        this.visible = !hasName || !hasCompanyName;
      });
    }
  },
  created() {
    this.loadIndustry()
  },
  methods: {
    loadIndustry() {
      this.$http
          .get(`/basic_data/industry?fetch_all=1`)
          .then(response => {
            if (response.success) {
              this.industry = response.data
            }
          })
    },
    onSubmit() {
      this.$refs["imporveForm"].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.$http
              .post("personal/profile", this.form)
              .then(response => {
                if (!response.success) {
                  this.$alert(response.message, "错误", {
                    showCancelButton: false,
                    type: 'error'
                  });
                } else {
                  //关闭窗口
                  this.visible = false;
                  window.location.reload()
                }
              })
              .catch()
              .then(() => {
                this.disabled = false;
              });
        } else {
          return false;
        }
      });
    }
  }
};

</script>

<style scoped>
.dialog >>> .el-dialog__header {
  background-color: #0082e6;
  padding-bottom: 20px;
}

.dialog >>> .el-dialog__title {
  color: #fff;
}

.form-input {
  width: 100%;
}

.checkbox-group {
  display: inline-table !important;
  flex-wrap: wrap;
  justify-content: space-between;
}

.checkbox-group >>> .el-checkbox__input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}

.checkbox {
  width: 90px;
  margin-left: 0 !important;
  text-align: center;

}

.checkbox:nth-child(-n+3) {
  margin-bottom: 12px
}

.checkbox >>> .el-checkbox__label {
  padding-left: 0 !important
}

</style>



// WEBPACK FOOTER //
// src/components/_widget/ImproveProfile.vue